import React from "react";
import "./service-options.scss";

const ServiceOptions = ({
  pickup = false,
  delivery = false,
  loading = true,
}) => {
  if (loading) return <></>;

  return (
    <>
      <div className="service-options">
        {pickup && <div className="option">Pick Up</div>}
        {delivery && <div className="option alternate">Delivering</div>}
      </div>
    </>
  );
};

export default ServiceOptions;
